<template>
  <div>
    <b-row>
      <SelectField
        v-model="documentFolder"
        name="document_folder_id"
        :label="__('documents.folder')"
        :options="documentFolders"
        class="col-12"
      />
    </b-row>

    <div class="text-right">
      <b-button size="sm" class="mr-2" variant="primary" @click="submit">
        <Icon icon="save" class="mr-2" size="14" />
        {{ __('buttons.save') }}
      </b-button>

      <b-button size="sm" variant="outline-primary" @click="closeModal()">
        <Icon icon="times" class="mr-2" size="14" />
        {{ __('buttons.cancel') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'
import DocumentModel from '@/Modules/Document/DocumentModel.js'
import DocumentMoveMixin from '@/Modules/Document/Mixins/DocumentMoveMixin.js'
import EntityDocumentService from '@/Modules/Entity/EntityDocument/EntityDocumentService.js'

export default {
  name: 'MoveDocumentModal',

  mixins: [ModalMixin, DocumentMoveMixin],

  props: {
    meta: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      DocumentModel,
      documentFolder: new DocumentModel(this.meta.documentFolder || {}),
      documentFolders: [],
    }
  },

  methods: {
    submit() {
      this.$nextTick(() => this.errors.clear())
      if (!this.meta.entityId) {
        return
      }

      if (_.isArray(this.meta.document)) {
        EntityDocumentService.moveDocumentsInBulk(
          this.meta.entityId,
          this.getPayload()
        )
          .then(() => {
            this.onSuccess && this.onSuccess()
            this.closeModal(this.__('documents.move-success'))
          })
          .catch((error) => this.setErrorsFromResponse(error))

        return
      }

      EntityDocumentService.moveDocument(
        this.meta.entityId,
        this.meta.document.id,
        this.getPayload()
      )
        .then(() => {
          this.onSuccess && this.onSuccess()
          this.closeModal(this.__('documents.move-success'))
        })
        .catch((error) => this.setErrorsFromResponse(error))
    },

    getPayload() {
      let data = {}

      if (this.documentFolder.value) {
        data.document_folder_id = this.documentFolder.value
      }

      if (_.isArray(this.meta.document)) {
        data.documents_ids = _.map(
          this.meta.document,
          (document) => document?.id || document
        )
      }

      return data
    },
  },
}
</script>
